import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import { Routes, Route } from 'react-router-dom';
import { connect } from "react-redux";

// Api Response Toaster
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import Routes all
import { frontEndRoutes, frontEndRoutesWithAuthCustomer, frontEndRoutesWithAuthDriver, frontEndNotAuthRoutes, frontEndRoutesWithAuth } from "./routes/frontEndRoutes";

// Import all middleware
import FrontAuthmiddlewareDriver from 'routes/middleware/FrontEndMiddlewareDriver';
import FrontAuthmiddlewareCustomer from 'routes/middleware/FrontEndMiddlewareCustomer';
import FrontEndNonAuthMiddleware from 'routes/middleware/FrontEndNonAuthMiddleware';
import FrontEndMiddleware from 'routes/middleware/FrontEndMiddleware';

import Pages404 from "./pages/Utility/pages-404";

import SplashScreen from './components/SplashScreen/index';

// Import scss
import "./assets/scss/theme.scss";
import FrontEndLayout from 'components/FrontEndLayout';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
// fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = () => {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 6000);
    return () => clearTimeout(timer);
  }, []);

  if (showSplash) {
    return <SplashScreen />;
  }

  return (
    <React.Fragment>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Routes>
        <Route>
          {frontEndRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <FrontEndLayout>
                  {route.component}
                </FrontEndLayout>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {frontEndNotAuthRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <FrontEndNonAuthMiddleware>
                  <FrontEndLayout>
                    {route.component}
                  </FrontEndLayout>
                </FrontEndNonAuthMiddleware>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {frontEndRoutesWithAuthDriver.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <FrontAuthmiddlewareDriver>
                  <FrontEndLayout>
                    {route.component}
                  </FrontEndLayout>
                </FrontAuthmiddlewareDriver>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {frontEndRoutesWithAuthCustomer.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <FrontAuthmiddlewareCustomer>
                  <FrontEndLayout>
                    {route.component}
                  </FrontEndLayout>
                </FrontAuthmiddlewareCustomer>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {frontEndRoutesWithAuth.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <FrontEndMiddleware>
                  <FrontEndLayout>
                    {route.component}
                  </FrontEndLayout>
                </FrontEndMiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route path="*" element={<Pages404 />} />
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
